import { useCallback } from 'react';
import type { IssueTransitionModalPayload } from '../../common/types';
import { EVENT_OPEN_ISSUE_TRANSITION_MODAL } from './constants';
import { ITSPubSub } from './index';

export const usePublishOpenIssueTransitionModalPubSub = () =>
	useCallback((payload?: IssueTransitionModalPayload, isEnabled?: boolean) => {
		ITSPubSub.publish(EVENT_OPEN_ISSUE_TRANSITION_MODAL, { payload, isEnabled });
	}, []);
